/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import Nav from "../nav/nav"
import Footer from "../footer/footer"
import CookieConsent from "react-cookie-consent"
import "./layout.scss"

const Layout = ({
  children,
  withBrand,
  withoutNav,
  fixed,
  slidePosition,
  btnBg,
  btnColor,
  background,
}) => {
  return (
    <div className="layout">
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        enableDeclineButton
        declineButtonText="Decline"
        cookieName="gatsby-gdpr-google-tagmanager"
        style={{
          alignItems: "center",
          background: "#444444",
          fontFamily: "'poppins'",
          fontSize: "13px",
          lineHeight: "22px",
          letterSpacing: "0.5px",
        }}
        buttonStyle={{
          backgroundColor: "#86c50f",
          borderRadius: "16px",
          color: "#ffffff",
          padding: "5px 24px",
        }}
        declineButtonStyle={{
          backgroundColor: "#939393",
          borderRadius: "16px",
          color: "#ffffff",
          padding: "5px 24px",
        }}
      >
        By clicking “Accept”, you agree to the storing of cookies on your device
        to enhance site navigation, analyze site usage, and assist in our
        marketing efforts. please see our{" "}
        <a href="/cookies-policy">Cookie Policy</a> for more information.
      </CookieConsent>
      {!withoutNav && (
        <Nav
          btnBg={btnBg}
          btnColor={btnColor}
          withBrand={withBrand}
          fixed={fixed}
          slidePosition={slidePosition}
        />
      )}
      <main>{children}</main>
      <Footer background={background} />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
